import { render } from "./ConversationHistoryReport.vue?vue&type=template&id=c6c5fdb4&scoped=true"
import script from "./ConversationHistoryReport.vue?vue&type=script&lang=js"
export * from "./ConversationHistoryReport.vue?vue&type=script&lang=js"

import "./ConversationHistoryReport.vue?vue&type=style&index=0&id=c6c5fdb4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6c5fdb4"]])

export default __exports__